import React from 'react'

const Help = () => {
  return (
    <div className='container'>
      <div className="text-center my-5">
      <h2 className='text-light'> this is for Help section..........</h2>
      </div>
      
    </div>
  )
}

export default Help
